export default "__VITE_ASSET__CaDyiTwD__"